// DO NOT EDIT THIS FILE UNLESS YOU KNOW WHAT YOU ARE DOING
// This file was either generated during yarn prepare or build
// TRANSLATION_BUNDLE_NAME = "master" will provide the translations for the latest merge to master
// TRANSLATION_BUNDLE_NAME = "hash..." will provide the translations for a specific build
// In most cases you will want "master" for local development

const TRANSLATION_BUNDLE_NAME = "master";

export { TRANSLATION_BUNDLE_NAME };
